var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLuckyIconTitleSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 24,
    viewBox: "0 0 129 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1363:1808",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.78125C0 2.14064 2.13814 0 4.77566 0H19.1963C21.8338 0 23.972 2.14064 23.972 4.78125V19.2188C23.972 21.8594 21.8338 24 19.1963 24H4.77566C2.13814 24 0 21.8594 0 19.2188V4.78125Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1363:1808)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22.972,
    height: 23,
    rx: 5.5,
    fill: "white",
    stroke: "#D1D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1333 10.3977H10.0998L11.9664 6.44531L13.9107 10.3977L17.8384 10.5139L14.8052 12.8388L17.1773 17.5662L11.9664 14.8925L6.79438 17.5662L9.32205 12.9938L6.1333 10.3977Z",
    fill: "#23272A"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7402 19.5498H40.4096V17.4294H34.2668V5.58618H31.7402V19.5498Z",
    fill: "#23272A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1608 15.1453C49.1608 16.7407 48.0235 17.5316 46.9338 17.5316C45.7489 17.5316 44.9589 16.693 44.9589 15.3635V9.07709H42.4936V15.7453C42.4936 18.2612 43.9237 19.6862 45.9804 19.6862C47.5468 19.6862 48.65 18.8612 49.1267 17.6885H49.2357V19.5498H51.6261V9.07709H49.1608V15.1453Z",
    fill: "#23272A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.724 19.7544C61.3528 19.7544 63.0281 18.193 63.2051 15.9703H60.8488C60.6377 17.0953 59.8273 17.743 58.7445 17.743C57.2053 17.743 56.2111 16.4544 56.2111 14.3135C56.2111 12.1998 57.2258 10.9316 58.7445 10.9316C59.9294 10.9316 60.6581 11.6953 60.8488 12.7044H63.2051C63.0349 10.4339 61.2642 8.94073 58.7104 8.94073C55.6458 8.94073 53.7117 11.1566 53.7117 14.3544C53.7117 17.5248 55.5981 19.7544 58.724 19.7544Z",
    fill: "#23272A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2295 19.5498H67.6948V16.0316L68.5937 15.0703L71.7945 19.5498H74.7434L70.4529 13.5975L74.505 9.07709H71.6243L67.865 13.2839H67.6948V5.58618H65.2295V19.5498Z",
    fill: "#23272A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7926 23.4771C79.7131 23.4771 80.8232 22.4885 81.4157 20.818L85.6176 9.09073L82.982 9.07709L80.5644 16.9862H80.4554L78.0446 9.07709H75.4295L79.2228 19.768L79.0117 20.3339C78.5554 21.5271 77.8335 21.6089 76.7575 21.2953L76.1854 23.218C76.5191 23.3544 77.1184 23.4771 77.7926 23.4771Z",
    fill: "#23272A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7939 13.4135C89.7939 11.8998 90.7065 11.0271 92.0073 11.0271C93.2808 11.0271 94.0435 11.8657 94.0435 13.2635V19.5498H96.5088V12.8816C96.5156 10.3725 95.0855 8.94073 92.9266 8.94073C91.3603 8.94073 90.2843 9.69073 89.8076 10.8566H89.685V9.07709H87.3286V19.5498H89.7939V13.4135Z",
    fill: "#23272A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.578 19.7544C106.642 19.7544 108.59 17.593 108.59 14.3544C108.59 11.1089 106.642 8.94073 103.578 8.94073C100.513 8.94073 98.5655 11.1089 98.5655 14.3544C98.5655 17.593 100.513 19.7544 103.578 19.7544ZM103.591 17.7771C101.896 17.7771 101.065 16.2635 101.065 14.3475C101.065 12.4316 101.896 10.8975 103.591 10.8975C105.26 10.8975 106.091 12.4316 106.091 14.3475C106.091 16.2635 105.26 17.7771 103.591 17.7771Z",
    fill: "#23272A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M115.906 9.07709H113.843V6.568H111.377V9.07709H109.893V10.9862H111.377V16.8089C111.364 18.7794 112.794 19.7475 114.646 19.693C115.348 19.6725 115.831 19.5362 116.097 19.4475L115.681 17.518C115.545 17.5521 115.266 17.6135 114.959 17.6135C114.34 17.6135 113.843 17.3953 113.843 16.3998V10.9862H115.906V9.07709Z",
    fill: "#23272A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M122.486 19.7544C124.924 19.7544 126.6 18.5612 127.036 16.7407L124.734 16.4816C124.4 17.368 123.583 17.8316 122.52 17.8316C120.927 17.8316 119.871 16.7816 119.851 14.9885H127.138V14.2316C127.138 10.5566 124.931 8.94073 122.357 8.94073C119.361 8.94073 117.406 11.143 117.406 14.3748C117.406 17.6612 119.333 19.7544 122.486 19.7544ZM119.858 13.3248C119.933 11.9885 120.92 10.8635 122.391 10.8635C123.808 10.8635 124.761 11.8998 124.775 13.3248H119.858Z",
    fill: "#23272A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuckyIconTitleSmall);
export default __webpack_public_path__ + "static/media/lucky_icon_title_small.d1d9df84f04eb1139d8c8eea974b4a8f.svg";
export { ForwardRef as ReactComponent };